import { useIntl } from 'react-intl';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons/faCircleExclamation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from 'ui-components/components/button';
import { FlexRow } from 'ui-components/components/flex/row';
import { Gap } from 'ui-components/components/flex/gap';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

import { messages } from './wwex-edit-link.messages';
import { WwexEditIcon } from './wwex-edit-icon';
import style from './wwex-edit-link.module.less';

type WwexEditLinkProps = {
  hasError?: boolean;
  isDisabled?: boolean;
  onClick: () => void;
};

export const WwexEditLink = ({ hasError = false, isDisabled = false, onClick }: WwexEditLinkProps) => {
  const intl = useIntl();

  return (
    <FlexRow gap={Gap.Space8}>
      {hasError && (
        <Tooltip position='top'>
          <TooltipContent>{intl.formatMessage(messages.hasErrorTooltip)}</TooltipContent>
          <FontAwesomeIcon className={style.errorIcon} icon={faCircleExclamation} />
        </Tooltip>
      )}
      <Button ariaLabel={intl.formatMessage(messages.editButtonLabel)} disabled={isDisabled} onClick={onClick} theme={THEME_CONSTANTS.link}>
        <FlexRow className={style.editContent} gap={Gap.Space4}>
          <WwexEditIcon />
          <Text textType={TextType.Paragraph} value={messages.editButtonLabel} />
        </FlexRow>
      </Button>
    </FlexRow>
  );
};
